import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: ({ images }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    overflow: 'hidden',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundImage: images && `url(${images.sm})`,
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
      backgroundImage: images && `url(${images.lg})`,
    },
  }),
  headline: {
    paddingBottom: '.635rem',
  },
  captionContainer: ({ isHovered, showMobileCaption }) => ({
    maxHeight: '100%',
    backgroundColor: theme.palette.opaque.white,
    transition: 'transform 200ms ease-in-out',
    transform: (isHovered || showMobileCaption) ? 'none' : 'translateY(100%)',
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px ${theme.spacing(4)}px`,
  }),
  captionButton: {
    backgroundColor: ({ showMobileCaption }) => (showMobileCaption ? 'transparent' : theme.palette.background.default),
    position: 'absolute',
    minWidth: 0,
    width: '3.125rem',
    height: '3.125rem',
    scale: '0.6',
    bottom: '0',
    right: '0',
    borderRadius: '100%',
    transition: '250ms',
    '&:hover': {
      backgroundColor: theme.palette.background.default,
      opacity: '.8',
    },
  },
  icon: {
    scale: '1.2',
  },
}))

export default useStyles
